import * as React from "react";
import { StandardProps } from "@material-ui/core";

import { withStyles, createStyles } from "./mui/styles";

import FirstPage from "./icons/FirstPage";
import LastPage from "./icons/LastPage";
import NavigateBefore from "./icons/NavigateBefore";
import NavigateNext from "./icons/NavigateNext";
import PaginationButton from "./PaginationButton";


export type PaginationActionsClassKey = 'root';

export interface PaginationActionsProps extends StandardProps<{}, PaginationActionsClassKey> {
    //extends WithStyles<typeof styles> {
    count: number;
    page: number;
    rowsPerPage: number;
    pageCount?: number;
    onChangePage: (nextPage: number) => void;
}

interface PgBtnItem {
    title: string;
    pg: number;
    selected?: boolean;
    break?: boolean;
}

interface PgBtnProps extends PgBtnItem {
    onChangePage: (nextPage: number) => void;
}

class PgBtn extends React.PureComponent<PgBtnProps>{
    render() {
        const { title, pg, selected } = this.props;
        const onClick = selected ? undefined : () => this.props.onChangePage(pg);
        return <PaginationButton onClick={onClick} selected={selected} >{title}</PaginationButton>;
    }
}

class PaginationActions extends React.PureComponent<PaginationActionsProps>{

    private handleFirstPageButtonClick = (event: any) => {
        this.props.onChangePage(0);
    };

    private handleBackButtonClick = (event: any) => {
        this.props.onChangePage(this.props.page - 1);
    };

    private handleNextButtonClick = (event: any) => {
        this.props.onChangePage(this.props.page + 1);
    };

    private handleLastPageButtonClick = (event: any) => {
        this.props.onChangePage(Math.max(0, Math.ceil(this.props.count / this.props.rowsPerPage) - 1));
    };

    private getPageItems = () => {
        const { count, page, rowsPerPage } = this.props;
        let { pageCount } = this.props;
        const numPages = Math.ceil(count / rowsPerPage);
        pageCount = pageCount || 0;
        const pageBlocks = Math.ceil(numPages / pageCount);
        const pgInBlock = Math.floor(page / pageCount);
        const items: PgBtnItem[] = [];

        let pageNumber: number;
        let index: number;

        if (numPages <= pageCount) {
            for (index = 0; index < numPages; index++) {
                pageNumber = index + 1;
                items.push({ title: `${pageNumber}`, pg: index, selected: page === index });
            }
        } else {

            let start = (pgInBlock * pageCount);
            let end = start + pageCount;
            if (end > numPages) {
                end = numPages;
                start = end - pageCount;
            }




            if (pgInBlock > 0) {
                index = Math.max(0, start - pageCount);
                items.push({ title: `...`, pg: index });

            }

            for (index = start; index < end; index++) {
                pageNumber = index + 1;
                items.push({ title: `${pageNumber}`, pg: index, selected: page === index });
            }

            if (pgInBlock < pageBlocks - 1) {
                index = end;
                items.push({ title: `...`, pg: index });

            }
        }

        return items;
    }

    render() {
        const { classes, count, page, rowsPerPage } = this.props;

        return <div className={classes.root}>
            <PaginationButton onClick={this.handleFirstPageButtonClick} disabled={page === 0} aria-label="First Page">
                <FirstPage />
            </PaginationButton>
            <PaginationButton onClick={this.handleBackButtonClick} disabled={page === 0} aria-label="Previous Page">
                <NavigateBefore />
            </PaginationButton>

            {this.getPageItems().map((p, k) => <PgBtn key={k} {...p} onChangePage={this.props.onChangePage} />)}

            <PaginationButton onClick={this.handleNextButtonClick} disabled={page >= Math.ceil(count / rowsPerPage) - 1} aria-label="Next Page" >
                <NavigateNext />
            </PaginationButton>

            <PaginationButton onClick={this.handleLastPageButtonClick} disabled={page >= Math.ceil(count / rowsPerPage) - 1} aria-label="Last Page" >
                <LastPage />
            </PaginationButton>
        </div>
    }
}

const styles = () => createStyles({
    root: {
        marginRight: 0
    }
});


export default withStyles(styles)(PaginationActions);
